module.exports = __webpack_public_path__ + "static/img/1.96ce93c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/nav-3/1.png
// module id = +VMp
// module chunks = 0